"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Download = function Download(_ref) {
  var size = _ref.size,
      color = _ref.color,
      secondaryColor = _ref.secondaryColor;
  return _react["default"].createElement(_SvgIcon["default"], {
    title: "download",
    size: size
  }, _react["default"].createElement("path", {
    fill: color,
    d: "M6 4.15c.63-.1 1.11-.61 1.11-1.23 0-.7-.6-1.25-1.33-1.25-.22 0-.43.05-.6.13-.29-.57-.9-.97-1.62-.97-.99 0-1.78.75-1.78 1.67-.5 0-.9.37-.9.83 0 .46.4.84.9.84H2c.22 0 .4.18.4.41A.4.4 0 012 5h-.22C.8 5 0 4.25 0 3.33c0-.65.4-1.21.98-1.49A2.65 2.65 0 013.56 0c.78 0 1.5.32 2 .84h.22C7 .83 8 1.76 8 2.91 8 4 7.12 4.89 6 4.99a.4.4 0 01-.4-.42.4.4 0 01.4-.41v-.01z"
  }), _react["default"].createElement("path", {
    fill: secondaryColor,
    d: "M3.5 5.33V3a.5.5 0 011 0v2.33h.59a.5.5 0 01.42.78L4.44 7.7a.5.5 0 01-.83 0L2.54 6.1a.5.5 0 01.42-.78h.54z"
  }));
};

Download.defaultProps = {
  size: 8,
  color: '#444',
  secondaryColor: '#444'
};
var _default = Download;
exports["default"] = _default;